module.exports = __webpack_public_path__ + "static/media/space.48f388d7.png";